// extracted by mini-css-extract-plugin
export default {"audioPlayerContainer":"AudioPlayer_audioPlayerContainer__QHoXP"};